import Form from 'components/Form';
import { IFormValues, IFormRegister } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormRegister {
  disabled?: boolean;
}

const SpecialReasone = (props: Props) => {
  const { disabled, getValues, setValue, register } = props;

  return (
    <>
      <SectionTitle title="5. 기타 필요하다고 판단되어 시술한 경우" />
      <RowContainer xs={12}>
        <RowContent title="상태변화 요약" titleRatio={1.3} childrenRatio={10.7}>
          <Form.MuiTextField
            required={false}
            fullWidth
            disabled={disabled}
            placeholder="추가적인 내용을 적어주세요. "
            {...register('special_reason')}
          />
        </RowContent>
      </RowContainer>
    </>
  );
};

export default SpecialReasone;
